import React__default from 'react';
import { useConfiguratorContext } from '../../../../Context/ConfiguratorContext.js';
import { Expander } from './Expander.js';

const ExpanderContainer = ({ children  })=>{
    const { isFooterOpen  } = useConfiguratorContext();
    return /*#__PURE__*/ React__default.createElement(Expander, {
        isExpanded: isFooterOpen
    }, children);
};

export { ExpanderContainer };
//# sourceMappingURL=ExpanderContainer.js.map
